import _ from 'lodash';

import template from './upgrade.html';
import './upgrade.scss';

class UpgradeController {
    /*@ngInject*/
    constructor(templateData, upgradeService, constants, catalogService, dataContext, cartService, $uibModal) {
        this.templateData = templateData;
        this.dataContext = dataContext;
        this.upgradeService = upgradeService;
        this.$uibModal = $uibModal;
        this.constants = constants;
        this.catalogService = catalogService;
        this.cartService = cartService;
        this.panelFirmware = '';
        this.upgrade = false;
        this.firmwareUpgrade = false;
    }

    $onInit() {
        this.getPaymentInfo().then(() => {
            this._setRequiredFirmware();
            this._setRequiredPlanUrl();
        });
    }

    selectUpgrade(upgrade) {
        this.onUpgrade({ upgrade: upgrade });
        this.upgrade = upgrade;
    }

    _setRequiredFirmware() {
        this.cartService.getCart().then((cart) => {
            this.catalogService.getProduct(_.map(cart.data.items, 'productId')).then(productsResponse => {
                return _.forEach(productsResponse.data, (product) => {
                    return this.dataContext.product.getProductIdFromSku(_.replace(product.sku, '__', '^'))
                        .then((result) => {
                            this.product = result;
                            if (this.product.IsZWave) {
                                this.isValidPanelFirmware()
                                    .then((isValid) => {
                                        if (!isValid) {
                                            this.firmwareUpgrade = true;
                                            this._openDialog();
                                        }
                                    });
                            }
                        });
                });
            });
        });
    }

    getPanelFirmware() {
        return this.dataContext.user.getAdcCustomerInfo()
            .then((result) => {
                return result.detailedPanelVersionField;
            });
    }

    isValidPanelFirmware() {
        return this.getPanelFirmware().then((firmwareVersion) => {
            if (_.includes(firmwareVersion, 'Simon XT')) {
                return true;
            }
            if (_.isNil(firmwareVersion)) {
                return true;
            }
            const panelFirmware = firmwareVersion.replace(/[^0-9\.]|[.]/g, '');
            return !(parseFloat(this.constants.firmware.versionNeededForZWave.replace(/[.]/g, '')) >
                parseFloat(_.padEnd(panelFirmware, 3, '0')));
        });

    }

    _openDialog() {
        let modalInstance = this.$uibModal.open({
            template: '<fp-firmware-upgrade-modal config="config"></fp-firmware-upgrade-modal>',
            size: 'md',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            }
        });
    }

    _setRequiredPlanUrl() {
        this.isLoading.upgradePlan = true;
        this.upgradeService.getRequiredPlanUpgrade().then(response => {
            this.planUpgrade = response;
            if (response !== 'none') {
                let plans = [];
                _.forEach(this.constants.monitoringPlans, monitoringPlan => {
                    plans.push({ name: 'code', value: monitoringPlan.abbreviation });
                });
                this.catalogService.searchProducts(plans).then(catalogResponse => {
                    let match = _.find(catalogResponse.data.products, { sku: response.PlanCode });
                    if (!_.isNil(match)) {
                        this.requiredPlanUrl = match.url.replace('~/', '');
                        this.planMonthlyCost = this.getPlanCost(match);
                        return this.dataContext.emergency.getMonitoringAdcInfo()
                            .then((result) => {
                                let currentPlan = _.find(this.constants.monitoringPlans, { name: result.WbServicePlanName }).abbreviation;
                                let currentPlanCatalog = _.find(catalogResponse.data.products, { sku: currentPlan });
                                let currentPlanPrice = this.getPlanCost(currentPlanCatalog);
                                this.planMonthlyCostDifference = this.planMonthlyCost - this.paymentInfo.Rmr;
                            });
                    }
                }).finally(() => {
                    this.isLoading.upgradePlan = false;
                });
            } else
                this.isLoading.upgradePlan = false;
        }).catch(() => {
            this.isLoading.upgradePlan = false;
        });
    }

    getPlanCost(catalog) {
        return _.find(catalog.properties, { displayName: 'monthly_price' }).value;
    }

    getPaymentInfo() {
        return this.dataContext.payment.getPaymentInfo()
            .then(response => {
                this.paymentInfo = response.PaymentInfo;
            });
    }
}



export default {
    template: template,
    bindings: {
        isLoading: '=',
        onUpgrade: '&'
    },
    controller: UpgradeController
};